import React from 'react'
import PurchaseItemListTable from './Componate/PurchaseItemListTable'
import AddItemBtn from "Common/Custom/AddItemBtn";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

const PurchaseItemList = () => {
  return (
    <PageBody
      card={true}
      headerchildren={
        <>
          <HeadingOne>Purchase Items List</HeadingOne>
          <AddItemBtn url="add-purchase-item" title="Create" />
        </>
      }>

      {/* Table section */}
      <div className="col-12">
        <PurchaseItemListTable />
      </div>
    </PageBody>
  );
};

export default PurchaseItemList;
